import React, { useState } from "react";
import { TYPES } from "../../envs/core";
import { PlacesProvider } from "../../dataProvider/places";
import Autocomplete from "../../components/autocomplete";
import "./style.scss";
import Module from "./module";
import {
  getElectionName,
  MODULE_TYPES,
  MODULES_A3,
  MODULES_LASEXTA,
  MODULES_LOCATION_A3,
  MODULES_LOCATION_LASEXTA
} from "./utils";
import ElTabs from "../../components/elTabs";
import ButtonGenerator from "./buttonGenerator";

const ModuleGenerator = () => {
  const [moduleParameters, setModuleParameters] = useState({
    type: TYPES.GENERAL
  });
  const [navegable, setNavegable] = useState(true);
  const [regionAutocomple, setRegionAutocomple] = useState("");
  const [provinceAutocomple, setProvinceAutocomple] = useState("");
  const [townAutocomple, setTownAutocomple] = useState("");

  const setType = type => {
    console.log(type);
    setModuleParameters({ ...moduleParameters, type });
  };

  const setLocation = location => {
    setModuleParameters({ ...moduleParameters, location });
  };

  const reset = () => {
    setModuleParameters({ type: TYPES.GENERAL, location: null });
  };

  const { type, location } = moduleParameters;

  const host = window.location.hostname;
  const isLocalhost = host.indexOf("localhost") !== -1;
  const isLaSexta = host.indexOf("lasexta") !== -1;

  const modulos = isLocalhost
    ? MODULE_TYPES
    : isLaSexta
    ? MODULES_LASEXTA
    : MODULES_A3;
  const modulosLocation = isLaSexta
    ? MODULES_LOCATION_LASEXTA
    : MODULES_LOCATION_A3;

  return (
    <div className="GenerateIframePage">
      <h1>Generador de módulos</h1>
      <button className="button" onClick={() => reset()}>
        Reset
      </button>
      <div>
        <h2>Tipo</h2>
        <div className="tabsContainer">
          <section className="titles">
            {Object.keys(TYPES).map(key => (
              <div
                key={key}
                type="button"
                className={TYPES[key] === type ? "title current" : "title"}
                onClick={() => setType(TYPES[key])}
              >
                {getElectionName(key)}
              </div>
            ))}
          </section>
        </div>
      </div>

      {type && (
        <div>
          <h2>Selecciona lugar</h2>
          <h3>Navegable</h3>
          <input
            type="checkbox"
            onChange={e => setNavegable(!navegable)}
            checked={navegable}
            value={navegable}
          ></input>
          <div className="row">
            <div className="three">
              <h3>Comunidad</h3>
              {type === TYPES.MUNICIPAL ? (
                <div>No disponible para este módulo</div>
              ) : (
                <PlacesProvider type="REGION" name={regionAutocomple}>
                  {data => {
                    return (
                      <Autocomplete
                        results={data}
                        onChange={value => setRegionAutocomple(value)}
                        onSelect={select => setLocation(select)}
                        placeholder="Escribe una comunidad autónoma"
                        showArrow
                      />
                    );
                  }}
                </PlacesProvider>
              )}
            </div>
            <div className="three">
              <h3>Provincia</h3>
              <PlacesProvider
                type="PROVINCE"
                name={provinceAutocomple}
                parentId={regionAutocomple.id}
              >
                {data => {
                  return (
                    <Autocomplete
                      results={data}
                      onChange={value => setProvinceAutocomple(value)}
                      onSelect={select => setLocation(select)}
                      placeholder="Escribe una provincia"
                      showArrow
                    />
                  );
                }}
              </PlacesProvider>
            </div>
            <div className="three">
              <h3>Localidad</h3>
              <PlacesProvider
                type="TOWN"
                name={townAutocomple}
                parentId={provinceAutocomple.id}
              >
                {data => {
                  return (
                    <Autocomplete
                      results={data}
                      onChange={value => setTownAutocomple(value)}
                      onSelect={select => setLocation(select)}
                      placeholder="Escribe una localidad"
                      showArrow
                    />
                  );
                }}
              </PlacesProvider>
            </div>
          </div>
        </div>
      )}

      {type && !location && type === TYPES.GENERAL && (
        <div>
          <h2>Módulos {location && location.name}</h2>
          <ElTabs titles={Object.values(modulos)}>
            {Object.keys(modulos).map(key => {
              if (key === "BUTTONS") {
                return (
                  <ButtonGenerator
                    navegable={navegable}
                    type={modulos[key]}
                    electionType={type}
                    electionName={type}
                  />
                );
              }
              return (
                <Module
                  navegable={navegable}
                  type={modulos[key]}
                  electionType={type}
                  electionName={type}
                />
              );
            })}
          </ElTabs>
        </div>
      )}

      {type &&
        location &&
        location.typePlace !== "TOWN" &&
        type === TYPES.GENERAL && (
          <div>
            <h2>Módulos {location && location.name}</h2>
            <ElTabs titles={Object.values(modulosLocation)}>
              {Object.keys(modulosLocation).map(key => {
                if (key === "BUTTONS") {
                  return (
                    <ButtonGenerator
                      navegable={navegable}
                      type={modulosLocation[key]}
                      electionType={type}
                      location={location}
                      electionName={type}
                    />
                  );
                }
                return (
                  <Module
                    navegable={navegable}
                    type={modulosLocation[key]}
                    electionType={type}
                    location={location}
                    electionName={type}
                  />
                );
              })}
            </ElTabs>
          </div>
        )}

      {type &&
        location &&
        (type !== TYPES.GENERAL || location.typePlace === "TOWN") && (
          <div>
            <h2>Módulos {location && location.name}</h2>
            <ElTabs titles={Object.values(modulosLocation)}>
              {Object.keys(modulosLocation).map(key => {
                if (key === "BUTTONS") {
                  return (
                    <ButtonGenerator
                      navegable={navegable}
                      type={modulosLocation[key]}
                      electionType={type}
                      location={location}
                      electionName={type}
                    />
                  );
                }
                return (
                  <Module
                    navegable={navegable}
                    type={MODULE_TYPES.RESULTADOS}
                    electionType={type}
                    electionName={type}
                    location={location}
                  />
                );
              })}
            </ElTabs>
          </div>
        )}
    </div>
  );
};

export default ModuleGenerator;
